
<template>
  <div class="activeUsers">
    <div class="activeUsers-change">
      <el-select v-model="year" placeholder="请选择" @change="getDataByYear">
        <el-option
          v-for="item in yearList"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-select v-model="month" placeholder="请选择" @change="getDataByMonth">
        <el-option
          v-for="item in list"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
    </div>
    <div id="lineChart" ref="lineChart"></div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
export default {
  name: 'ActiveUsers',
  data() {
    return {
      month: '1月',
      year: '2022年',
      lineChart: null,
      list: [
        { value: '01', label: '1月' },
        { value: '02', label: '2月' },
        { value: '03', label: '3月' },
        { value: '04', label: '4月' },
        { value: '05', label: '5月' },
        { value: '06', label: '6月' },
        { value: '07', label: '7月' },
        { value: '08', label: '8月' },
        { value: '09', label: '9月' },
        { value: '10', label: '10月' },
        { value: '11', label: '11月' },
        { value: '12', label: '12月' }
      ],
      yearList: [
        { value: 2022, label: '2022年' },
        { value: 2021, label: '2021年' }
      ]
    }
  },
  mounted() {
    this.initChart()
  },
  methods: {
    initChart() {
      const that = this
      this.lineChart = echarts.init(this.$refs.lineChart)
      const option = this.getOption()
      this.lineChart.setOption(option, true)
      window.addEventListener('resize', () => {
        that.lineChart.resize()
      })
    },
    getOption() {
      const options = {
        color: ['#34ACFF', '#FF7D00'],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow' // 'shadow' as default; can also be 'line' or 'shadow'
          }
        },
        legend: {
          itemWidth: 10,
          itemHeight: 10,
          top: '5%',
          textStyle: {
            color: '#fff',
            fontSize: 12
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          show: false
        },
        yAxis: {
          type: 'category',
          data: [
            '丽水市',
            '缙云县',
            '松阳县',
            '庆元县',
            '龙泉市',
            '莲都区',
            '青田县',
            '景宁畲族自治县',
            '遂昌县'
          ].reverse(),
          axisLabel: {
            color: 'rgba(255, 255, 255,1)',
            fontSize: 14
          },
          axisTick: {
            show: false
          }
        },
        series: [
          {
            name: '非活跃用户',
            type: 'bar',
            stack: 'total',
            /* label: {
              show: true
            }, */
            emphasis: {
              focus: 'series'
            },
            data: [320, 300, 150, 150, 150, 150, 150, 200, 200]
          },
          {
            name: '活跃用户',
            type: 'bar',
            stack: 'total',
            /* label: {
              show: true
            }, */
            emphasis: {
              focus: 'series'
            },
            data: [180, 200, 350, 350, 350, 350, 350, 300, 300]
          }
        ]
      }
      return options
    },
    getDataByYear() {},
    getDataByMonth() {}
  }
}
</script>
<style lang='scss' scoped>
/deep/ .el-select {
  width: 1.5rem;
  margin-right: 0.2rem;
  .el-input__inner {
    height: 0.32rem;
    color: rgba(255, 255, 255, 100);
    background-color: rgba(11, 24, 35, 1);
    border: 0.01rem solid rgba(45, 56, 75, 1);
  }
  .el-input--medium .el-input__icon {
    line-height: 0.32rem;
  }
}
.activeUsers {
  width: 100%;
  height: 98%;
  #lineChart {
    width: 100%;
    height: 86%;
  }
}
</style>
